export const environment = {
  production: true,
  apiUrl: "https://api.equinemedirecord.com/api/v1",
  socketUrl: "https://api.equinemedirecord.com",
  socketPort: ":6001",
  maxImgCount: 5,
  maxImgSize: "20971520", // in bytes
  defaultLanguage: "en",
  languages: [],
  country: "ireland",
  availableCountries: {
    ireland: "https://app.equinemedirecord.com",
    uk: "https://uk-app.equinemedirecord.com",
    france: "https://fr.equinemedirecord.com",
    usa: "https://us.equinemedirecord.com",
    sa: "https://sa.equinemedirecord.com",
    ma: "https://ma-app.equinemedirecord.com",
    aus: "https://rv-app.equinemedirecord.com"    
  },
  stripeKey: "pk_live_QpectWcXspdGw4Tn06bA0F7p",
  quick_treatment: false,
  currency: "EUR",
  showRegionsSelect: true, //only for USA
  ruleBookPdf: null,
  ruleBookKYPdf: null,
  ruleBookCAPdf: null,
  ruleBookBCPdf: null,
  ruleBookBCPdPopup: null,
  ruleBookBC2023Pdf: null,
  ruleBookBC2023PdfPopup: null,
  filterRegionForDrugs: false,
  showModalUnvaccinated: true,
  showInTheFoodChainToggle: true,
  dateFormat: "dd/MM/yyyy",
  disableTreatmentEditInstructorNotOwned: false, //If set to true instructor (trainer) can not edit treatments not created by him.
  currentCountry: "ie",
  vaccinationCountries: ["uk", "fr"],
  ruleBookPCPdf: "",
  ruleBookPCPopup: "",
  ruleBookPKPdf: "",
  ruleBookPKPdfPopup: "",
  vaccinationDocumentUrl: "",
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts